import { useEffect } from 'react';

const SITE_NAME = 'PCCenter';

// The backend already renders "<name> | PCCenter" into the first page load
// (see the backend's seo module); this keeps the title right as the visitor
// navigates in-app. Keep the format in step with the server's.
export function useDocumentTitle(name: string | null | undefined): void {
    useEffect(() => {
        if (!name) return;
        document.title = `${name} | ${SITE_NAME}`;
        return () => {
            document.title = SITE_NAME;
        };
    }, [name]);
}
